import React from "react";

export const snackbarRef = React.createRef();